

























import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    login () {
        utils.my_post({apiName:"login",
            params: {
                ui_code:this.current.usercode,
                ui_password:this.current.password,
                isCookie:this.current.isCookie,
                yzm:this.current.yzm
            },
            ok: (json:any, dataAll:any) => {
                utils.login({user: json})
            }})
    }


}

